export enum TestTypeEnum {
  Theory = 'theory',
  Practical = 'practical',
}
